import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { changeBackgroundColorMenu, openClose } from 'src/assets/models/animations';
import { ScreenService } from '../../services/screen.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    AppRoutingModule
  ],
  animations: [
    openClose,
    changeBackgroundColorMenu
  ]
})
export class MenuComponent {
  
  isHomePage = true;
  router: Router = inject(Router);
  viewportScroller: ViewportScroller = inject(ViewportScroller)
  currentRoute!: string;
  opened: boolean = false;

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      this.isHomePage = this.router.url.startsWith('/inicio');
      if(event instanceof NavigationStart)
        this.currentRoute != event.url ? this.opened = false : this.opened 
      if(event instanceof NavigationEnd)
        this.currentRoute = event.url;
    })
  }

  openOrCloseMenu() {
    this.opened = !this.opened
  }

  screenService: ScreenService = inject(ScreenService);
  navigateAnchor(value: number) {
    this.screenService.emitValue(value);
  }

  navigateTo(anchor: number) {
    sessionStorage.setItem("navigateTo", anchor.toString());
    this.router.navigate(['/inicio']);
  }
}
